import { ImageType } from 'types/Image'
import { FRONTEND_BASE_URL } from 'utils'

import { httpClient, uploadClient } from './clients/httpClient'

export const uploadShowImages = async (files: File[]): Promise<any> => {
    try {
        const formData = new FormData()
        files.forEach((file) => formData.append('files', file))

        const response = await uploadClient.post('/images/upload', formData)

        console.log('Files uploaded successfully:', response.data)
        return response.data
    } catch (error) {
        console.error('Error uploading files:', error)
        throw new Error('Failed to upload files')
    }
}

export const getImageById = async (imageId: string): Promise<ImageType> => {
    try {
        const { data } = await httpClient.get(`/images/${imageId}`)

        if (!data) {
            throw new Error('Image not found')
        }

        return formatImage(data[0])
    } catch (error) {
        console.error('Error fetching image:', error)
        throw new Error('Failed to fetch image')
    }
}

export const getImagesByIds = async (imageIds: string[]): Promise<ImageType[]> => {
    try {
        const responses = await Promise.all(
            imageIds.map(async (id) => {
                const { data } = await httpClient.get(`/images/${id}`)

                if (!data) {
                    throw new Error(`Image with ID ${id} not found`)
                }

                return formatImages(data)
            }),
        )

        return responses.flat()
    } catch (error) {
        console.error('Error fetching images:', error)
        throw new Error('Failed to fetch images')
    }
}

const formatImage = (imageData: any): ImageType => {
    return {
        image_id: imageData.image_id,
        image_url: `${FRONTEND_BASE_URL}${imageData.image_url}`,
    }
}

const formatImages = (imagesData: any[]): ImageType[] => {
    return imagesData.map(formatImage)
}
